import styled, { css } from 'styled-components';

import { ScAvatarProps } from '@/helpers/avatar';

export const ScAvatar = styled.img<ScAvatarProps>`
  width: 100%;
  height: auto;
  border-radius: 70px;
  overflow: hidden;
  transition: 0.3s ease-in-out;
  background-color: ${({ theme }) => theme.gray1Color};
  cursor: ${({ isListItem }) => (!isListItem ? 'default' : 'pointer')};

  &.selected {
    border: 2px solid #ea5b0c;
  }

  ${({ isListItem }) =>
    isListItem &&
    css`
      &:hover {
        border: 2px solid #ea5b0c;
      }
    `}
`;
